var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("Shows Assignment History Grid")]),_c('ag-grid-vue',{staticClass:"ag-theme-balham default-grid",attrs:{"column-defs":_vm.assignmentHistoryColumnDefs,"row-data":_vm.rowData},on:{"grid-ready":_vm.onGridReady}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }